export const bonuses = [
  {
    num: '01',
    title: 'Zestaw szybkich modyfikacji ćwiczeń',
    desc: 'Wersje A, B i C każdego ćwiczenia. Jedne zajęcia dla grup o różnym poziomie zaawansowania.',
    value: '47 zł',
    image: 'https://cdn.magicpatterns.com/uploads/eqeDSg6g4diAti5yWAKD9M/BONO_1.webp',
  },
  {
    num: '02',
    title: '20 gotowych rozgrzewek',
    desc: 'Rozgrzewki dopasowane do każdej sesji. W wersji ekspresowej i pełnej.',
    value: '35 zł',
    image: 'https://cdn.magicpatterns.com/uploads/fCaPZFY3PamDSxYdjZXw3Y/BONO_2.webp',
  },
  {
    num: '03',
    title: '20 gotowych protokołów wyciszenia i zakończenia zajęć',
    desc: 'Kończ każde zajęcia jak profesjonalista. Gotowe scenariusze zakończenia w zestawie.',
    value: '35 zł',
    image: 'https://cdn.magicpatterns.com/uploads/nD9g4y69s2TCTU6odpo7dA/BONO_3.webp',
  },
  {
    num: '04',
    title: '50 zwrotów i gotowych scenariuszy coachingowych',
    desc: 'Dokładne słowa, które motywują, korygują i prowadzą Twoją grupę.',
    value: '31 zł',
    image: 'https://cdn.magicpatterns.com/uploads/4QrssFmZvzKvJgaCwuUkz6/BONO_4.webp',
  },
  {
    num: '05',
    title: 'Główny planer systemu',
    desc: 'Widok roczny, miesięczny, tygodniowy i dzienny. Koniec z improwizacją.',
    value: '47 zł',
    image: 'https://cdn.magicpatterns.com/uploads/ciJXeojHDdNc8JVNBAbyBA/BONO_5.webp',
  },
]
